import dayjs from "dayjs"

import { DATE_FORMAT } from "@/constants/formats"
import { type Location, type UnitOfMeasurement } from "@/graphql/codegen/graphql"
import { formatCurrency } from "@/utils/currency"

export { FREIGHT_TERMS_TO_LABEL, INCOTERMS_TO_LABEL } from "@/constants/shippingTerms"

type LocationLabelFields = Pick<Location, "name" | "description" | "city" | "region">

export const formatPurchaseCostDate = (isoDate: string | null | undefined): string => {
  if (!isoDate) return ""
  return dayjs(isoDate).format(DATE_FORMAT.US)
}

export const formatPurchaseCostDateShort = (isoDate: string | null | undefined): string => {
  if (!isoDate) return ""
  return dayjs(isoDate).format(DATE_FORMAT.US_SHORT)
}

export const formatWarehouseLabel = (location: LocationLabelFields): string => {
  const cityRegion = [location.city, location.region?.name].filter(Boolean).join(", ")
  const description = location.description || location.name || ""
  return cityRegion ? `${description} - ${cityRegion}` : description
}

export const formatIncotermsLocationLabel = (location: LocationLabelFields): string => {
  const cityRegion = [location.city, location.region?.name].filter(Boolean).join(", ")
  const description = location.description || location.name || ""
  const prefix = location.name || description
  return cityRegion ? `${prefix}: ${description} - ${cityRegion}` : `${prefix}: ${description}`
}

export const formatUomLabel = (uomId: string, units: UnitOfMeasurement[]): string => {
  const unit = units.find((currentUnit) => currentUnit.id === uomId)
  return unit?.name ?? unit?.description ?? uomId
}

export const formatTierPrice = (price: number, uomLabel: string): string => `${formatCurrency(price)} / ${uomLabel}`

export const formatTierQty = (qty: number): string => `${qty.toLocaleString("en-US")} QTY`
